// extracted by mini-css-extract-plugin
export default {"cardHeaderIcon":"c-e_cT","cardHeaderIcon_styleDefault":"c-e_cU","cardHeaderIcon_styleRed":"c-e_cV","cardHeaderIcon__content":"c-e_cW"};